import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutSwitcher, useStructuredDataEmbedding } from '../_puzzles/shared/utils';
import ArithmeglyphsPreview from '../ContentTiles/ArithmeglyphsPreview/ArithmeglyphsPreview';
import MegarubigramPreview from '../ContentTiles/MegarubigramPreview';
import UltrarubigramPreview from '../ContentTiles/UltrarubigramPreview';
import MorphologyPreview from '../ContentTiles/MorphologyPreview';
import PathwordPreview from '../ContentTiles/PathwordPreview';
import Pathword5x5Preview from '../ContentTiles/Pathword5x5Preview';
import RubigramPreview from '../ContentTiles/RubigramPreview';
import TriwordPreview from '../ContentTiles/TriwordPreview';
import TruthsortingPreview from '../ContentTiles/TruthsortingPreview';
import WeeklyWisdom from '../ContentTiles/WeeklyWisdom';
import Horoscopes from '../ContentTiles/Horoscopes';
import Schedule from '../ContentTiles/Schedule';
import Announcement from '../ContentTiles/Announcement';
import JigsawHaikuLink from '../ContentTiles/JigsawHaikuLink';
import '../ContentTiles/PreviewTiles.less';
import './MainContentGrid.less';

const showAnnouncement = true;

const MainContentGrid = () => {
  const navigate = useNavigate();
  useStructuredDataEmbedding(null);

  const goTo = (url: string) => {
    return () => {
      navigate(url);
      window.scrollTo(0, 0);
    };
  };

  let layout = useLayoutSwitcher();

  if (layout === 1) {
    return (
      <div className="mainContentGrid threeColumns">
        <div className="column">
          <PathwordPreview onClick={goTo('/pathword')}/>
          <hr className="tileSeparator"/>
          <WeeklyWisdom/>
          <hr className="tileSeparator"/>
          <TriwordPreview onClick={goTo('/triword')}/>
          <hr className="tileSeparator"/>
          <Pathword5x5Preview onClick={goTo('/pathword5x5')}/>
        </div>
        <div className="columnSeparator"/>
        <div className="column">
          <MorphologyPreview onClick={goTo('/morphology')}/>
          <hr className="tileSeparator"/>
          <div className="previewTile">
            <div className="featureTitle">Want the Baffle in Your Pocket?</div>
            <div className="announcement" style={{ textAlign: 'center' }}>Mobile app free for both <a href="https://apps.apple.com/app/id6755982312">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.dailybaffle.mobile">Android</a>!</div>
          </div>
          <hr className="tileSeparator"/>
          <ArithmeglyphsPreview onClick={goTo('/arithmeglyphs')}/>
          <hr className="tileSeparator"/>
          <Schedule/>
          <hr className="tileSeparator"/>
          <UltrarubigramPreview onClick={goTo('/ultrarubigram')}/>
        </div>
        <div className="columnSeparator"/>
        <div className="column">
          {showAnnouncement && <><Announcement/>
          <hr className="tileSeparator"/></>}
          <TruthsortingPreview onClick={goTo('/truthsorting')}/>
          <hr className="tileSeparator"/>
          <JigsawHaikuLink/>
          <hr className="tileSeparator"/>
          <RubigramPreview onClick={goTo('/rubigram')}/>
          <hr className="tileSeparator"/>
          <Horoscopes/>
          <hr className="tileSeparator"/>
          <MegarubigramPreview onClick={goTo('/megarubigram')}/>
        </div>
      </div>
    );
  } else if (layout === 2) {
    return (
      <div className="mainContentGrid twoColumns">
        <div className="column">
          <PathwordPreview onClick={goTo('/pathword')}/>
          <hr className="tileSeparator"/>
          <WeeklyWisdom/>
          <hr className="tileSeparator"/>
          <TriwordPreview onClick={goTo('/triword')}/>
          <hr className="tileSeparator"/>
          <RubigramPreview onClick={goTo('/rubigram')}/>
          <hr className="tileSeparator"/>
          <Pathword5x5Preview onClick={goTo('/pathword5x5')}/>
          <hr className="tileSeparator"/>
          <UltrarubigramPreview onClick={goTo('/ultrarubigram')}/>
        </div>
        <div className="columnSeparator"/>
        <div className="column">
          {showAnnouncement && <><Announcement/>
          <hr className="tileSeparator"/></>}
          <MorphologyPreview onClick={goTo('/morphology')}/>
          <hr className="tileSeparator"/>
          <JigsawHaikuLink/>
          <hr className="tileSeparator"/>
          <div className="previewTile">
            <div className="featureTitle">Want the Baffle in Your Pocket?</div>
            <div className="announcement" style={{ textAlign: 'center' }}>Mobile app free for both <a href="https://apps.apple.com/app/id6755982312">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.dailybaffle.mobile">Android</a>!</div>
          </div>
          <hr className="tileSeparator"/>
          <TruthsortingPreview onClick={goTo('/truthsorting')}/>
          <hr className="tileSeparator"/>
          <ArithmeglyphsPreview onClick={goTo('/arithmeglyphs')}/>
          <hr className="tileSeparator"/>
          <Horoscopes/>
          <hr className="tileSeparator"/>
          <MegarubigramPreview onClick={goTo('/megarubigram')}/>
          <hr className="tileSeparator"/>
          <Schedule/>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mainContentGrid oneColumn">
        <div className="column">
          {showAnnouncement &&
          <>
            <Announcement/>
            <hr className="tileSeparator"/>
          </>}
          <MorphologyPreview onClick={goTo('/morphology')}/>
          <hr className="tileSeparator"/>
          <TruthsortingPreview onClick={goTo('/truthsorting')}/>
          <hr className="tileSeparator"/>
          <JigsawHaikuLink/>
          <hr className="tileSeparator"/>
          <div className="previewTile">
            <div className="featureTitle">Want the Baffle in Your Pocket?</div>
            <div className="announcement" style={{ textAlign: 'center' }}>Mobile app free for both <a href="https://apps.apple.com/app/id6755982312">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.dailybaffle.mobile">Android</a>!</div>
          </div>
          <hr className="tileSeparator"/>
          <PathwordPreview onClick={goTo('/pathword')}/>
          <hr className="tileSeparator"/>
          <WeeklyWisdom/>
          <hr className="tileSeparator"/>
          <TriwordPreview onClick={goTo('/triword')}/>
          <hr className="tileSeparator"/>
          <RubigramPreview onClick={goTo('/rubigram')}/>
          <hr className="tileSeparator"/>
          <ArithmeglyphsPreview onClick={goTo('/arithmeglyphs')}/>
          <hr className="tileSeparator"/>
          <Horoscopes/>
          <hr className="tileSeparator"/>
          <Pathword5x5Preview onClick={goTo('/pathword5x5')}/>
          <hr className="tileSeparator"/>
          <MegarubigramPreview onClick={goTo('/megarubigram')}/>
          <hr className="tileSeparator"/>
          <UltrarubigramPreview onClick={goTo('/ultrarubigram')}/>
          <hr className="tileSeparator"/>
          <Schedule/>
        </div>
      </div>
    );
  }
};

export default MainContentGrid;
